import React from 'react';
import { useTrackOptimizely } from '@fff-web/fff-analytics';
import { SubscriptionUpdatePaymentModal, UpdatePaymentModalV2 } from '@fff-web/fff-payments';
import { useReactivateMyMembershipContext } from '../../../utils/ContextProviders/ReactivateContext';
import { GROWTH_MY_REACTIVATE_MEMBERSHIP } from '../../../utils/Optimizely/featureFlagVariations';

type UpdatePaymentModalContainerProps = {
  onClose: () => void;
  subtitle: string;
  isOpen: boolean;
  onSuccess: () => void;
  hasError: boolean;
};

const UpdatePaymentModalContainer: React.FunctionComponent<UpdatePaymentModalContainerProps> = (
  props,
) => {
  const { growthMyMembership } = useReactivateMyMembershipContext();
  useTrackOptimizely(growthMyMembership, GROWTH_MY_REACTIVATE_MEMBERSHIP.EXPERIMENT_NAME);
  const isVariationK =
    growthMyMembership?.variationKey === GROWTH_MY_REACTIVATE_MEMBERSHIP.VARIATION_K;

  return isVariationK ? (
    <UpdatePaymentModalV2 {...props} />
  ) : (
    <SubscriptionUpdatePaymentModal {...props} />
  );
};

export default UpdatePaymentModalContainer;
